import React from 'react';
import PropTypes from 'prop-types';

import './customProgressBar.css';
import { Typography } from '@mui/material';

export default function CustomProgressBar({ title, actualValue, targetValue }) {
  const calculateProgress = () =>
    (actualValue / targetValue) * 100 > 99 ? '100%' : `${(actualValue / targetValue) * 100}%`;
  const calculateBackgroundColor = () => {
    const percentage = (actualValue / targetValue) * 100;

    if (percentage > 81) {
      return '#008000';
    }

    if (percentage > 30 && percentage <= 80) {
      return '#DFFF00';
    }

    return '#f72b29';
  };

  return (
    <div className='custom-progress-bar-container'>
      <div>
        <Typography variant='h5'>{title}</Typography>
      </div>
      <div className='cpb'>
        <div className='cpv-target-label'>
          <Typography variant='h5'>{`${((actualValue / targetValue) * 100 ?? 0).toFixed(
            2,
          )}%`}</Typography>
        </div>
        <div className='cpb-actual-label'>
          <Typography variant='h5'>{`${actualValue} / ${targetValue}`}</Typography>
        </div>
        <div
          className='cpb-progress'
          style={{
            width: calculateProgress(),
            backgroundColor: calculateBackgroundColor(),
            color: '#000',
          }}
        />
      </div>
    </div>
  );
}

CustomProgressBar.propTypes = {
  title: PropTypes.string.isRequired,
  actualValue: PropTypes.number.isRequired,
  targetValue: PropTypes.number.isRequired,
};
